import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  container: {
    margin: "100px 60px",
  },
  heading: {
    fontSize: "8rem !important",
  },
  subheading: {
    fontSize: "34px !important",
    marginBottom: "20px !important",
  },
  button: {
    padding: "20px 50px !important",
    fontSize: "14px !important",
  },
}));
